import React, { useState, useContext } from 'react';
import UserDetailsContext from '../context/userDetails.context';
import LocationsContext from '../context/locations.Context';
import ThemeContext from '../context/theme.Context';
import LoadingContext from '../context/loading.context';
import NotificationContext from '../context/notification.Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import * as Constants from '../modules/constants';


function ManageLocations(props) {

    const { locations, setLocations } = useContext(LocationsContext);
    const { showLoading, hideLoading } = useContext(LoadingContext);
    const { userId, token } = useContext(UserDetailsContext);
    const { showMessage } = useContext(NotificationContext);

    const [locationData, setLocationData] = useState(initializeLocationData);

    const apiHostName = Constants.API_URL;

    function initializeLocationData() {
        var names = {};
        Object.values(locations).forEach(location =>
            names[location.id] = { id: location.id, name: location.name, owner: location.owner, authorization: location.authorization }
        );
        return names;
    }

    function setLocationName(locationId, value) {
        setLocationData(prevState => {
            return { ...prevState, [locationId]: { ...prevState[locationId], name: value } };
        });
    }

    function addLocation() {
        // Add a location on the server
        const locationName = window.prompt('Please enter the name for the new location', 'New location');
        if (!locationName)
            return;

        showLoading();
        fetch(apiHostName + '/v1/locations', {
            mode: "cors",
            method: 'POST',
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ Name: locationName })
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Invalid network response");
                }
                return response.json();
            })
            .then((result) => {
                // Result contains the new location details:
                // Add location on this page:
                setLocationData(prevState => {
                    return {
                        ...prevState, [result.id]: { id: result.id, name: result.name, owner: userId, authorization: '' }
                    };
                });
                // Also add location to locations, so navigation menu & LocalStorage are updated:
                setLocations({ newLocations: { ...locations, [result.id]: { id: result.id, name: result.name, owner: userId, authorization: '' } } });
                hideLoading();
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on login screen
                console.error("Adding location failed...");
                console.error(error);
                hideLoading();
                showMessage({ newMessage: 'Network error' });
            });

    }

    function updateLocationName(locationId) {
        // Update location on the server:
        showLoading();
        fetch(apiHostName + '/v1/locations/' + locationId + '?name=' + encodeURIComponent(locationData[locationId].name), {
            mode: "cors",
            method: 'PUT',
            headers: {
                "Authorization": "Bearer " + token
            }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Invalid network response");
                }
                return response.text();
            })
            .then((result) => {
                // Update locations, so navigation menu & localStorage are updated:
                setLocations({
                    newLocations: {
                        ...locations, [locationId.toString()]: {
                            ...locations[locationId.toString()], name: locationData[locationId.toString()].name
                        }
                    }
                });
                hideLoading();
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on login screen
                console.error("Updating location failed...");
                console.error(error);
                hideLoading();
                showMessage({ newMessage: 'Network error' });
            });

    }


    function deleteLocation(locationId) {
        // Delete location on server
        if (!window.confirm('Are you sure you want to delete location ' + locations[locationId].name + '?\nAll devices, groups and invited users will be removed as well!'))
            return;

        showLoading();
        fetch(apiHostName + '/v1/locations/' + locationId, {
            mode: "cors",
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer " + token
            }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Invalid network response");
                }
                return response.text();
            })
            .then((result) => {
                // Remove location from locationsData, so the UI in this component is updated:
                setLocationData(prevState => {
                    let { [locationId.toString()]: _, ...remainingLocations } = prevState;
                    return { ...remainingLocations };
                });
                // Update "locations", so location is also removed from navigation menu, and stored in LocalStorage:
                let { [locationId.toString()]: _, ...updatedLocations } = locations;
                setLocations({ newLocations: updatedLocations });
                hideLoading();
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on login screen
                console.error("Deleting location failed...");
                console.error(error);
                hideLoading();
                showMessage({ newMessage: 'Network error' });
            });

    }

    function manageUsers(locationId) {
        props.history.push({
            pathname: '/manageUsers',
            state: { locationId: locationId }
        });
    }

    function removeLocation(locationId) {
        // Remove this location from this user on server
        if (!window.confirm('Are you sure you want to remove location ' + locations[locationId].name + '?\nThis location will not be available for you any more!'))
            return;

        showLoading();
        fetch(apiHostName + '/v1/locations/' + locationId + '/' + encodeURIComponent(userId), {
            mode: "cors",
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer " + token
            }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Invalid network response");
                }
                return response.text();
            })
            .then((result) => {
                // Remove location from locationsData, so the UI in this component is updated:
                setLocationData(prevState => {
                    let { [locationId.toString()]: _, ...remainingLocations } = prevState;
                    return { ...remainingLocations };
                });
                // Update "locations", so location is also removed from navigation menu, and stored in LocalStorage:
                let { [locationId.toString()]: _, ...updatedLocations } = locations;
                setLocations({ newLocations: updatedLocations });
                hideLoading();
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on login screen
                console.error("Removing location failed...");
                console.error(error);
                hideLoading();
                showMessage({ newMessage: 'Network error' });
            });
    }

    return (
        <ThemeContext.Consumer>
            {(themeContext) => (
                <Card bg={themeContext.theme} text={themeContext.textColor}>
                    <Card.Body>
                        <Card.Title>
                            Manage locations <Button variant='secondary' title="Add new location" style={{ marginLeft: '30px' }} onClick={addLocation}><FontAwesomeIcon icon="plus-circle" /></Button>{' '}
                        </Card.Title>
                        <Card.Subtitle>
                            Add, remove or update locations
                        </Card.Subtitle>
                        <Card.Text as="div" style={{ paddingTop: '2em' }}>
                            <div>Your locations:</div>
                            {Object.values(locationData).map(location => {
                                return location.owner === userId && (
                                    <div key={location.id} style={{ display: 'flex', marginBottom: '5px' }}>
                                        <Form.Control type='text' maxLength={100} value={location.name} onChange={(e) => { setLocationName(location.id, e.target.value); }} />
                                        <Button variant='secondary' title="Update location name" onClick={() => updateLocationName(location.id)}><FontAwesomeIcon icon="edit" /></Button>
                                        <Button variant='secondary' title="Manage users" style={{ marginLeft: '5px' }} onClick={() => manageUsers(location.id)}><FontAwesomeIcon icon="users" /></Button>
                                        <Button variant='secondary' title="Delete location" style={{ marginLeft: '5px' }} onClick={() => deleteLocation(location.id)}><FontAwesomeIcon icon="trash-alt" /></Button>
                                    </div>
                                );
                            }
                            )}



                            <div>Other locations:</div>
                            {Object.values(locationData).map(location => {
                                return (location.owner !== userId &&
                                    <div key={location.id} style={{ display: 'flex', marginBottom: '5px' }}>
                                        <Form.Control type='text' maxLength={100} value={location.name} disabled />
                                        <Button variant='secondary' title="Update location name" disabled ><FontAwesomeIcon icon="edit" /></Button>
                                        <Button variant='secondary' title="Manage users" disabled style={{ marginLeft: '5px' }} ><FontAwesomeIcon icon="users" /></Button>
                                        <Button variant='secondary' title="Remove location" style={{ marginLeft: '5px' }} onClick={() => removeLocation(location.id)}><FontAwesomeIcon icon="minus-circle" /></Button>
                                    </div>
                                );
                            }
                            )}
                        </Card.Text>
                    </Card.Body>
                </Card>

            )}
        </ThemeContext.Consumer>
    );
}

export default ManageLocations;


// WEBPACK FOOTER //
// ./src/components/ManageLocations.js